import React from 'react';
import Link from 'next/link';
import { withAgentLogin } from '@components/hoc/with-auth/with-auth';
import AgentsGenericPageLayout from './AgentsGenericPageLayout';
import { useI18NextContext } from '@components/hooks';
import styled from '@emotion/styled';
import { ThemeProps } from '@theme/base';
import { SectionSeparator } from '@styles/layout';
import { Page } from '@model/common';
import { Agent } from '@model/agents/agents-models';
import { AgentPage, AgentsPageProps } from '@model/common/pages/agent-pages';
import { FacebookWrapper, FacebookSDK } from '@components/social';

export interface AgentsHomePageProps extends AgentsPageProps {
  agent: Agent;
}

const Abta = styled.h4(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h4 as any),
  margin: 0,
  fontWeight: 'normal'
}));

const Welcome = styled.p(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any)
}));

const Intro = styled.span({
  fontWeight: 'bold'
});

const AgentsHomePageLayout = (props: AgentsHomePageProps) => {
  const {
    agent: { abta, name }
  } = props;
  const t: any = useI18NextContext();
  return (
    <AgentsGenericPageLayout
      {...props}
      textProps={{ agentName: name }}
      main={
        <div>
          <FacebookSDK />
          <Abta>{t('agents__home--sub-title', { abta })}</Abta>
          <Welcome>
            <Intro>{t('agents__home--text-intro')}</Intro>
            {t('agents__home--text-build-1')}
            <Link href={Page.AGENTS.concat(AgentPage.BOOKINGS)}>{t('agents__home--text-link-1')}</Link>
            {t('agents__home--text-build-2')}
            <Link href={Page.AGENTS.concat(AgentPage.INCENTIVES)}>{t('agents__home--text-link-2')}</Link>
            {t('agents__home--text-build-3')}
            <Link href={Page.AGENTS.concat(AgentPage.NEWS_AND_PROMOTIONS)}>{t('agents__home--text-link-3')}</Link>
            {t('agents__home--text-build-4')}
            <Link href={Page.AGENTS.concat(AgentPage.WINDOW_POSTERS)}>{t('agents__home--text-link-4')}</Link>
            {t('agents__home--text-build-5')}
            <Link href={Page.AGENTS.concat(AgentPage.SOCIAL_MEDIA_POST)}>{t('agents__home--text-link-5')}</Link>.
          </Welcome>
          <Welcome>
            {t('agents__home--text-addn')}
            <Link href={Page.AGENTS.concat(AgentPage.MEET_YOUR_TEAM)}>{t('agents__home--text-addn-link')}</Link>.
          </Welcome>
          <SectionSeparator size={20} />
          <FacebookWrapper />
        </div>
      }
    />
  );
};

export default withAgentLogin(AgentsHomePageLayout);
